module.exports = __webpack_public_path__ + "img/kz.23430419.svg";